import { EuiConfirmModal, EuiFieldText } from "@inscopix/ideas-eui";
import axios from "axios";
import { getEnvVar } from "ideas.env";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { getRequestHeaders } from "utils/getRequestHeaders";

const CONFIRM_TEXT = "delete";

/**
 * Deletes a new tool.
 * @param toolId
 */
const deleteTool = async (toolId: number) => {
  const url = getEnvVar("URL_TRS_TOOL_SCHEDULE_DELETE")(toolId);
  const headers = await getRequestHeaders();
  const body = { date_deleted: new Date().toISOString() };
  await axios.patch(url, body, { headers });
};

interface ModalDeleteToolProps {
  toolId: number;
  onClose: () => void;
}

export const ModalDeleteTool = ({ toolId, onClose }: ModalDeleteToolProps) => {
  const tenantKey = useTenantContext((s) => s.currentTenant.key);
  const toolRoute = useRouteMapContext((s) => s.routeMap.ORGANIZATION_TOOLS);
  const [confirmation, setConfirmation] = useState("");

  const handleConfirm = async () => {
    try {
      await deleteTool(toolId);
      toolRoute.dynamicPath({ tenantKey }).navigateToReplace();
      addUtilityToastSuccess("Tool deleted");
    } catch (error) {
      addUtilityToastFailure("Failed to delete tool");
    }
  };

  return (
    <EuiConfirmModal
      title="Permanently deprecate all versions and delete this tool?"
      onCancel={onClose}
      onConfirm={() => void handleConfirm()}
      cancelButtonText="Cancel"
      confirmButtonText="Delete Tool"
      buttonColor="danger"
      defaultFocusedButton="confirm"
      confirmButtonDisabled={confirmation !== CONFIRM_TEXT}
    >
      <p>
        This will make all versions of this tool unavailable for all members of
        your organization. Proceed with caution - this cannot be undone.
      </p>

      <p>
        <b>To confirm, type &quot;{CONFIRM_TEXT}&quot; in the box below</b>
      </p>

      <EuiFieldText
        autoFocus
        value={confirmation}
        onChange={(e) => setConfirmation(e.target.value.toLowerCase().trim())}
        name="confirmation"
      />
    </EuiConfirmModal>
  );
};
